import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataSource } from '@angular/cdk/collections';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fuseAnimations } from '@fuse/animations';
import *  as $ from 'jquery';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from 'app/main/pagina/modal/modal.component';
import { ColaboradoresN35Service  } from 'app/main/wizard-n35encuestador/services/colaboradoresn35.service';
import { WizardN35EncuestadorService } from 'app/main/wizard-n35encuestador/services/wizardn35encuestador.services';
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import {AuthService} from 'app/auth/auth.service';
import {Subscription} from 'rxjs';

interface adverModal {
  tipo: number;
  mensaje: string;
  diccionario: string;
  confirma: boolean;
};

import * as XLSX from 'xlsx';
import { Colaborador35 } from './colabs35.interfaz';

type AOA = any[][];

@Component({
  selector: 'upload-bd35',
  templateUrl: './colabs35.component.html',
  styleUrls: ['./colabs35.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations : fuseAnimations
})
export class Colabs35Component implements OnInit {
  centered = false;
  disabled = false;
  unbounded = false;

  radius: number;
  color: string;
  // files: any = [];
  public imagePath;
  imgURL: any;
  public message: string;
  data: AOA = [ [1, 2], [3, 4] ];
  datax: Colaborador35[] = [];
  userIsAuthenticated = false;
  private authListenerSubs: Subscription;
  cargandoBD = false;
  guardandoBD = false;

   //Variables progress bar
   iter = 0;
   totRows = 0;
   barPorcen = 0;
   // Datos certificar vigente
   productoCertificar: backInter.prodNorma35;
   //boolean paso completo
   pasoCompleto = false;
   public files: NgxFileDropEntry[] = [];

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    public authService: AuthService,
    private colaboradoresService: ColaboradoresN35Service ,
    private dialog: MatDialog,
    private wizardService: WizardN35EncuestadorService
  ) {
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authListenerSubs = this.authService
    .getAuthStatusListener()
    .subscribe(isAuthenticated => {
      this.userIsAuthenticated = isAuthenticated;
      // this.isLoading = false;
    });

    //this._fuseTranslationLoaderService.loadTranslations(lang_configuracion);
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    /*$(document).ready(function(){
      $(".finishBt").width($(".finishBt").parent().width());
    });
    $(window).resize(function(){
      $(".finishBt").width($(".finishBt").parent().width());
    });
    this.obtieneCertificarActual();*/
  }

  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      this.colaboradoresService.getStatusColaboradores(this.productoCertificar.fechaNorma35).subscribe( (data: backInter.getStatusIndiv) => {
        if(data.estatus === 3)
          this.pasoCompleto = true;
      });
      //obtiene las preguntas adicionales guardadas
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  completarPaso(){
    if(this.pasoCompleto){
      this.aletaRestric('COLABORADORES.COMPLETADO');
    }
    else{
      this.aletaRestric('COLABORADORES.COMPLETAR',true);
      //COLOCAR CONDICIONES Y VALIDACIONES PARA COMPLETAR EL PASO
    }

  }
  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }
  aletaRestric(mensaje:string,confirmar?:boolean){
      let infoModal: adverModal = {'tipo': 3, 'confirma': confirmar, 'mensaje': mensaje, 'diccionario': 'WIZARD.CERTIFICAR.'};
      const confirmaMod = this.dialog.open(ModalComponent, { data:infoModal });
      if(confirmar){
        confirmaMod.afterClosed().subscribe(resultado => {
          if(resultado){
            this.colaboradoresService.guardaStatusColaboradores(this.productoCertificar.fechaNorma35).subscribe( (data: backInter.RespuestaGen) => {
              if(data.message == '211'){
                this.aletaRestric('COLABORADORES.'+data.message);
                this.pasoCompleto = true;
                this.enviaOrdenWizard();
              };
            });
          }
        });
      }
  }

  public dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    for (const droppedFile of files) {

      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {

          // Here you can access the real file
          console.log(droppedFile.relativePath, file);

          /**
          // You could upload it like this:
          const formData = new FormData()
          formData.append('logo', file, relativePath)

          // Headers
          const headers = new HttpHeaders({
            'security-token': 'mytoken'
          })

          this.http.post('https://mybackend.com/api/upload/sanitize-and-save-logo', formData, { headers: headers, responseType: 'blob' })
          .subscribe(data => {
            // Sanitized logo returned from backend
          })
          **/

        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        console.log(droppedFile.relativePath, fileEntry);
      }
    }
  }

  uploadFile(event) {

    var mimeType = event[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      //return;
    }else{
       var reader = new FileReader();
        this.imagePath = event;
        reader.readAsDataURL(event[0]);
        reader.onload = (_event) => {
          this.imgURL = reader.result;
        }
    }

    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      console.log(element);
      console.log(element.value);
      this.files.push(element.name)
    }
  }

  ////LEER XLSM
  onFileChange(evt: any) {
    this.cargandoBD = true;
    let fec1 = new Date();
		/* wire up file reader */
		const target: DataTransfer = <DataTransfer>(evt.target);
		if (target.files.length !== 1) throw new Error('Cannot use multiple files');
		const reader: FileReader = new FileReader();
		reader.onload = (e: any) => {
			/* read workbook */
			const bstr: string = e.target.result;
			const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});

			/* grab first sheet */
			const wsname: string = wb.SheetNames[1];
			const ws: XLSX.WorkSheet = wb.Sheets[wsname];

			/* save data */
			this.data = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));
			// console.log(this.data.length);
      this.totRows = this.data.length;


			this.data.forEach( (elm) => {
				let xd = elm;
				if(xd.length == 19){
					//this.datax.push(xd);
					let colab: Colaborador35 = {
            productoId: this.productoCertificar.idNorma35,
						nombreCompleto:xd[0],
						numEmpleado:xd[1],
						anioNacimiento: xd[2],
						correoElectronico: xd[3],
						jefeDirecto: xd[4],
						pais: xd[5],
						localidad: xd[6],
						area: xd[7],
						cargoEmpresa: xd[8],
						cargoHomologado: xd[9],
						fechaIngreso: xd[10],
						condicionTrabajo: xd[11],
						esquemaCompensacion: xd[12],
						genero: xd[13],
						gradoAcademico: xd[14],
						telefonoColaborador: xd[15],
						extensionColaborador: xd[16],
						celularColaborador: xd[17],
						responde: xd[18],
						vivoColaborador: 1
						};

					this.datax.push(colab);
				}
        this.iter++;
        this.barPorcen = (100 / this.totRows) * this.iter;
        // console.log(this.barPorcen);
			});
      this.datax = this.datax.splice(1,this.datax.length);
				// console.log(this.datax);

      this.cargandoBD = false;
      let fec2 = new Date();
      let fx = (fec2.getTime() - fec1.getTime()) / 1000;

      console.log("registros cargados: "+this.datax.length);
      console.log("tiempo de carga de bd en front: "+fx+" segs");
      // console.log("valor final de barporcen: "+this.barPorcen);

      let arcs = evt.target.files
      for (let index = 0; index < arcs.length; index++) {
        const element = arcs[index];
        // console.log(element);
        this.files.push(element.name)
      }
		};

		reader.readAsBinaryString(target.files[0]);
	}

  enviarBD(){


    if(this.datax.length > 0){

      // this.authService.enviarBDColabs(this.datax);
      // this.authService.getAuthStatusListener().subscribe(guardado => {
      //   console.log(guardado);
      //   fin = new Date();
      //   let fx = (fin.getTime() - inicio.getTime()) / 1000;
      //   console.log("tiempo de guardado de bd en backend: "+fx+" segs");
      //   this.guardandoBD = false;
      //   this.deleteAttachment(0);
      // });


      Swal.fire({
        /*title: 'Are you sure?',*/
        text: '¿Confirma guardar la información de '+this.datax.length+' colaboradores?',
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.guardandoBD = true;
          let inicio = new Date();
          let fin: any;
          // this.colaboradoresService.enviaColaboradoresBD(this.datax).subscribe( (data: any) => {
          //   console.log(data);
          //   fin = new Date();
          //   let fx = (fin.getTime() - inicio.getTime()) / 1000;
          //   console.log("tiempo de guardado de bd en backend: "+fx+" segs");
          //   this.guardandoBD = false;
          //   this.deleteAttachment(0);
          //   Swal.fire({
          //     text: "La información de los colaboradores se almacenó correctamente",
          //     icon: 'success',
          //     confirmButtonColor: '#e40601'
          //   });
          // });
        }

      });

    }
    else {
      Swal.fire({
        text: "No ha cargado una base de datos de colaboradores",
        icon: 'warning',
        confirmButtonColor: '#e40601'
      });
      // this.dialog.open(ModalComponent, { data:{message:"No ha seleccionado una bd"} });
    }
  }


  deleteAttachment(index:number, origen?:boolean) {
    if(origen){
      Swal.fire({
        text: "La base de datos cargada se removió correctamente",
        icon: 'success',
        confirmButtonColor: '#e40601'
      });
    }
    this.files = [];
    this.data = [];
    this.datax = [];
    this.totRows = 0;
    this.iter = 0;
    this.barPorcen = 0;
  }

}
